// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"bB-z","smallCardRow":"cB-z","largeCardRow":"dB-z","productSearchRow":"eB-z","curatedRow":"fB-z"};